import { useEffect, useState } from "react";
import { fetchPublicTransportCommunityReports } from "../../../api/transportPublicApi";
import {
  TransportPublicAttribution,
  TransportPublicCtas,
  TransportPublicHero,
} from "../../../components/midpoint/transport/public/TransportPublicSections";
import { useTransportPublicSeo, trackTransportPublicEvent } from "../../../hooks/useTransportPublicSeo";
import TransportPublicLayout from "./TransportPublicLayout";

const TransportCommunityReportsPublicPage = () => {
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);

  useTransportPublicSeo(payload?.seo);

  useEffect(() => {
    let cancelled = false;
    fetchPublicTransportCommunityReports()
      .then((body) => {
        if (!cancelled) {
          setPayload(body);
          trackTransportPublicEvent("transport_public_page_view", { pageType: "community_reports" });
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load reports.");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error || !payload) {
    return (
      <TransportPublicLayout title="Community mobility reports">
        <p>{error || "Loading community reports…"}</p>
      </TransportPublicLayout>
    );
  }

  return (
    <TransportPublicLayout title="Community mobility reports">
      <TransportPublicHero hero={payload.hero} />
      <section className="transport-public-section">
        <h2>Public reports ({payload.count})</h2>
        <div className="transport-public-report-list">
          {(payload.reports || []).map((report) => (
            <article key={report.reportKey} className="transport-public-report-card">
              <strong>{report.title || report.categoryLabel}</strong>
              <div>
                <span className="transport-public-chip">{report.categoryLabel}</span>
                <span className="transport-public-chip">{report.severity}</span>
                <span className="transport-public-chip">
                  {report.isVerified ? "verified" : "unverified"}
                </span>
              </div>
              <p className="transport-public-disclaimer">{report.disclaimer}</p>
            </article>
          ))}
        </div>
      </section>
      <TransportPublicAttribution attribution={payload.attribution} />
      <TransportPublicCtas ctas={payload.ctas} />
    </TransportPublicLayout>
  );
};

export default TransportCommunityReportsPublicPage;
